@if (endpoint) {
  <div class="docs-section" [id]="endpoint.id">

    <div class="docs-ep-hero">
      <span class="endpoint-badge endpoint-badge--post">{{ endpoint.method }}</span>
      <span class="docs-ep-hero__path">{{ endpoint.path }}</span>
    </div>

    <p class="docs-subtitle">{{ endpoint.summary }}</p>
    <p class="docs-subtitle">
      Returns object <span class="docs-param">{{ endpoint.returns }}</span> the data object of a
      {{ endpoint.method }} {{ endpoint.id }} response. Cikisi wraps every response as
      <span class="docs-param">&#123; data, messages, success &#125;</span> the schema below describes
      <span class="docs-param">data</span>.
    </p>

    <div class="docs-section__head">
      <h2 class="docs-h2" [id]="endpoint.id + '-request'">Request body</h2>
    </div>

    <div class="docs-section">
      <p class="docs-subtitle"><strong>request</strong> · {{ generalRequestParams.length }} parameters what to search, and where to look.</p>
      <app-docs-param-list [items]="generalRequestParams"></app-docs-param-list>
    </div>

    <!-- Cikisi-only params pulled out of the table above (see DocsParam's
         own doc comment) only worth showing to a reader who's actually
         signed in to a Cikisi-connected organization; everyone else would
         just see parameters they can't use. -->
    @if (isCikisiUser) {
      <div class="docs-section">
        <h3 class="docs-h3" [id]="endpoint.id + '-request-cikisi'">Cikisi-only parameters</h3>
        <p class="docs-subtitle"><strong>request</strong> · {{ cikisiRequestParams.length }} parameters only sent for organizations connected to Cikisi, like yours.</p>
        <app-docs-param-list [items]="cikisiRequestParams"></app-docs-param-list>
      </div>
    }

    <div class="docs-section__head">
      <h2 class="docs-h2" [id]="endpoint.id + '-response'">Response body</h2>
    </div>

    <div class="docs-section">
      <p class="docs-subtitle"><strong>response</strong> · {{ endpoint.responseParams.length }} parameters how much to return, and in what shape.</p>
      <app-docs-param-list [items]="endpoint.responseParams"></app-docs-param-list>
    </div>

    <div class="docs-section">
      <h2 class="docs-h2" [id]="endpoint.id + '-example'">Example</h2>
      <div class="docs-code-panel">
        <div class="docs-code-panel__header">
          <div class="docs-code-tabs">
            @for (lang of languages; track lang.id) {
              <button type="button" class="docs-code-tab" [class.docs-code-tab--active]="activeLang() === lang.id" (click)="setLang(lang.id)">{{ lang.label }}</button>
            }
          </div>
          <button type="button" class="docs-copy-btn" [class.docs-copy-btn--copied]="copied" (click)="copyExample()">
            @if (copied) {
              Copied
            } @else {
              <svg width="13" height="13" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 2a2 2 0 00-2 2v6a2 2 0 002 2h5a2 2 0 002-2V6.828a2 2 0 00-.586-1.414l-2.828-2.828A2 2 0 008.172 2H6Z" fill="currentColor"/><path d="M3 5a1 1 0 00-1 1v7a2 2 0 002 2h6a1 1 0 100-2H4V6a1 1 0 00-1-1Z" fill="currentColor"/></svg>
              Copy
            }
          </button>
        </div>
        <pre class="docs-code-pre" [innerHTML]="exampleHtml"></pre>
      </div>

      <p class="docs-subtitle">Response:</p>

      <div class="docs-code-panel">
        <div class="docs-code-panel__header">
          <div class="docs-code-tabs">
            <button type="button" class="docs-code-tab docs-code-tab--active">200</button>
          </div>
        </div>
        <pre class="docs-code-pre" [innerHTML]="traceHtml"></pre>
      </div>
    </div>

    <!-- ── This endpoint's own response schemas ─────────────────── -->
    <div class="docs-section">
      <div class="docs-section__head">
        <h2 class="docs-h2" [id]="endpoint.id + '-schemas'">Response schemas</h2>
        <p class="docs-subtitle">
          Documentation only: nothing validates or coerces an upstream payload, and bodies are relayed untouched. A
          field marked nullable appears only when the include_* flag that produces it was set.
        </p>
      </div>

      @for (s of schemas; track s.name) {
        <div class="docs-schema">
          <p class="docs-schema__name">{{ s.name }}</p>
          @if (s.description) { <p class="docs-subtitle">{{ s.description }}</p> }
          <app-docs-param-list [items]="s.fields"></app-docs-param-list>
        </div>
      }
    </div>

  </div>
}
